import { connect, ConnectedProps } from 'react-redux'

import CaKeyPicks from 'components/ca/CaKeyPicks'
import { setSignUpModalIsOpen } from 'redux/actions'
import { RootState, AppDispatch } from 'redux/store'

const mapStateToProps = (state: RootState, ownProps: any): { isLogged: RootState['user']['isLogged'], aol: any } => ({
  isLogged: state.user.isLogged,
  aol: ownProps.aol
})

const mapDispatchToProps = (dispatch: AppDispatch): { setSignUpModalIsOpen: (isOpen: boolean) => ReturnType<AppDispatch> } => ({
  setSignUpModalIsOpen: (isOpen: boolean) => dispatch(setSignUpModalIsOpen(isOpen))
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export type CaKeyPicksContainerProps = ConnectedProps<typeof connector>

export default connector(CaKeyPicks)
